module.exports = __webpack_public_path__ + "staticesp/media/flautanovo.aee910a1.mp4";